import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const xtpXdpConnectionTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'XTP XDP Connection',
  key: 'xtpXdpConnection',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['name', 'ipduid', 'lbid'],
          ['destIp', '$empty', '$empty'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      type: {
        type: 'text',
        hide: 'true',
        initial: 'IPDU',
      },
      name: {
        label: 'Name',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'regexp',
              regexp: ['letters', 'digits'],
              errorMessage: 'Can include letters, digits. Please re-enter.'
            },
            {
              type: 'length',
              length: 16,
            },
          ],
        },
      },
      ipduid: {
        label: 'XDP ID',
        type: 'select',
        initial: '',
        options: [],
        optionsFirstTranslatable: true,
        validation: {
          required: true,
        },
      },
      lbid: {
        label: 'XTP IP Address',
        type: 'select',
        initial: '',
        options: [],
        optionsFirstTranslatable: false,
        validation: {
          required: true,
        },
      },
      groupid: {
        label: 'XDP Group ID',
        type: 'text',
        hide: 'true',
        initial: '0',
        validation: {
          validators: [
            {
              type: 'length',
              length: 2,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  0,
                  64,
                ],
              ],
              errorMessage: 'Must be between 0 - 64. Please re-enter.',
            },
          ],
        },
      },
      destIp: {
        label: 'XDP IP Address',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 50,
            },
            {
              type: 'IPAddress',
              errorMessage: 'Must be a valid IP Address. Please re-enter.',
            },
          ],
        },
      },
    },
  },
  protocol: {
    metadata: {
      layout: {
        rows: [
          ['axs', 'axsgp', 'etsiip'],
        ],
      },
    },
    fields: {
      axs: {
        type: 'checkbox',
        label: 'AXS',
        initial: false,
      },
      axsgp: {
        type: 'checkbox',
        label: 'AXSGP',
        initial: false,
      },
      etsiip: {
        type: 'checkbox',
        label: 'ETSIIP',
        initial: false,
      },
    },
  },
  protocolInterface: {
    metadata: {
      layout: {
        rows: [
          ['id', 'cfid', 'ifid'],
          ['destip', 'lbid', 'netid'],
          ['ipduid', 'transport', 'type'],
          ['destPort', 'trclvl', 'reqState'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      cfid: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      ifid: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      destip: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      lbid: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      netid: {
        type: 'text',
        hide: 'true',
        initial: 'xcp',
      },
      ipduid: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      transport: {
        type: 'text',
        hide: 'true',
        initial: 'TCP',
      },
      type: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      destPort: {
        label: 'Port',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  65535,
                ],
              ],
              errorMessage: 'Must be between 0 - 64. Please re-enter.',
            },
          ],
        },
      },
      trclvl: {
        label: 'Trace Level',
        type: 'select',
        initial: '0',
        options: [
          {
            label: 'None',
            value: '0'
          },
          {
            label: '1',
            value: '1'
          },
          {
            label: '2',
            value: '2'
          },
          {
            label: '3',
            value: '3'
          },
          {
            label: '4',
            value: '4'
          }
        ],
        optionsTranslatable: true
      },
      reqState: {
        label: 'Configured State',
        type: 'select',
        initial: 'ACTIVE',
        options: [
          {
            label: 'Active',
            value: 'ACTIVE'
          },
          {
            label: 'Inactive',
            value: 'INACTIVE'
          }
        ],
        optionsTranslatable: true
      },
    },
  },
};
